import { render } from "./DonationIntro.vue?vue&type=template&id=20883e05&scoped=true"
import script from "./DonationIntro.vue?vue&type=script&lang=js"
export * from "./DonationIntro.vue?vue&type=script&lang=js"

import "./DonationIntro.vue?vue&type=style&index=0&id=20883e05&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20883e05"]])

export default __exports__